export default "/img/BZ.ed940dff13a9f5a7abd3f2fd193ef00f.png";